var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHouseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,20v-8H2l10-9l4,3.6V4h3v5.3l3,2.7h-3v8h-5v-6h-4v6H5z M10,10h4c0-0.5-0.2-1-0.6-1.3C13,8.4,12.5,8.2,12,8.2 s-1,0.2-1.4,0.5C10.2,9.1,10,9.5,10,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHouseFill);
export default __webpack_public_path__ + "static/media/whiteHouseFill.0200b01f78c59f593160d886830ebc83.svg";
export { ForwardRef as ReactComponent };